import { combineReducers } from 'redux';

import loadingArraySlice from 'modules/global/reducers/loadingArraySlice';
import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';
import { ASSIGN_TEMPLATE_FROM_GROUP_SUCCESS } from 'modules/groups/actionTypes';

import * as types from '../../actionTypes';
import { GROUP_SOURCE } from '../../constants';
import type { DeleteTemplateAction, DeleteTemplateSuccessAction } from '../../types/actions';

const isGroupSource = ({ meta }: { meta?: { source?: string } }) => meta?.source === GROUP_SOURCE;

const removeDeletedGroupTemplateId = (state: string[], action: DeleteTemplateSuccessAction) => {
  if (!isGroupSource(action)) {
    return state;
  }
  return state.filter(id => id !== action.payload);
};

const appendAssignedTemplateId = (state: string[], { payload }: { payload: { id: string } }) => (state.includes(payload.id) ? state : [...state, payload.id]);

const selectDeletingId = (payload: DeleteTemplateAction['payload']) => (typeof payload === 'string' ? payload : payload?.templateId);

export default combineReducers({
  deleting: loadingArraySlice(types.DELETE_TEMPLATE, {
    global: { matcher: isGroupSource, selectId: selectDeletingId },
  }),
  dashboard: createSearchReducers(types.FETCH_GROUP_CUSTOM_TEMPLATE_REQUEST, {
    ids: {
      [types.DELETE_TEMPLATE_SUCCESS]: removeDeletedGroupTemplateId,
      [ASSIGN_TEMPLATE_FROM_GROUP_SUCCESS]: appendAssignedTemplateId,
    },
    global: { paginationSlice: true },
  } as unknown as Parameters<typeof createSearchReducers>[1]),
});
